function isShared(monitoring) {
  if (!monitoring) return false;

  return Boolean(
    monitoring.shareableKey &&
      monitoring.shareableUntil?.iso &&
      new Date(monitoring.shareableUntil.iso).getTime() > Date.now()
  );
}

export const Monitoring = {
  isShared
};
